var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "873px",
    height: "609px",
    viewBox: "0 0 873 609",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100.003289%",
    x2: "50%",
    y2: "-0.00328947368%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "-1.32098149e-15%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0.98,
    width: 768,
    height: 510.02,
    rx: 8.85
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_photo_4yb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.54,588.88 C872.561257,593.938492 870.570776,598.797956 867.007004,602.387987 C863.443232,605.978019 858.598512,608.004121 853.54,608.02 L19.54,608.02 C14.4780059,608.004135 9.63024031,605.975286 6.06589164,602.380922 C2.50154298,598.786557 0.513416801,593.921949 0.54,588.86 L0.54,19.16 C0.518743021,14.1015076 2.509224,9.24204427 6.07299608,5.65201282 C9.63676815,2.06198137 14.4814879,0.0358793779 19.54,0.02 L853.54,0.02 C858.601994,0.0358652005 863.44976,2.06471412 867.014108,5.65907835 C870.578457,9.25344258 872.566583,14.1180509 872.54,19.18",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.73,579.56 C862.73,589.788314 854.438314,598.08 844.21,598.08 L29.47,598.08 C19.2416864,598.08 10.95,589.788314 10.95,579.56 L10.95,28.8 C10.95,18.5716864 19.2416864,10.28 29.47,10.28 L844.21,10.28 C854.438314,10.28 862.73,18.5716864 862.73,28.8",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "5f7f4fba-1df4-4c9b-ab6f-3f66810cb66e",
    transform: "translate(43.000000, 36.000000)",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.49,
    y: 0.62,
    width: 787.52,
    height: 537.89,
    rx: 8.85
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 53.19,
    y: 49,
    width: 767.31,
    height: 510.36,
    rx: 8.85
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(53.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.46,506.68 L171.75,261.21 C179.211849,252.658047 189.775253,247.433825 201.100808,246.694304 C212.426363,245.954783 223.579424,249.760993 232.09,257.27 L292.09,310.2 C307.917026,324.167138 331.581295,324.452045 347.74,310.87 L531.06,156.75 C548.606873,142.014177 574.662629,143.780669 590.06,160.75 L815.06,408.39 C821.315973,415.277362 825.147447,424.021971 825.97,433.29 L834.65,530.98 C835.710906,542.90035 831.713613,554.717844 823.63431,563.546499 C815.555007,572.375153 804.137467,577.402211 792.17,577.4 L-10.35,577.4 C-33.4121282,577.404662 -52.2985211,559.072058 -52.98,536.02 C-53.3015573,525.26286 -49.5435896,514.781988 -42.46,506.68 Z",
    id: "Shape",
    fill: "#BFBFBF",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DFDFDF",
    fillRule: "nonzero",
    cx: 145.58,
    cy: 130.83,
    r: 47.52
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.e555a43d40d5cfa51998c94aa499b08c.svg";
export { ForwardRef as ReactComponent };